import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IColumnDescription, GridColumnDescription, FormGroupDescription } from './adapter_t';
import { nameof, TwoWayAdapter, IModelMetadata, From } from '@bds/core';

export class RtShopFact implements From<RtShopFact> {
    constructor(
        public shopNo?: string,
        public shopShortName?: string,
        public shopContact?: string,
        public comments?: string,
    ) {}
    from(obj: RtShopFact): RtShopFact {
        Object.keys(obj).forEach((k) => (this[k] = obj[k]));
        return this;
    }
}

export var relationship: IModelMetadata[] = [
    { client: nameof<RtShopFact>('shopNo'), server: 'shopNo' },
    { client: nameof<RtShopFact>('shopShortName'), server: 'shopShortName' },
    { client: nameof<RtShopFact>('shopContact'), server: 'shopContact' },
    { client: nameof<RtShopFact>('comments'), server: 'comments' },
];

@Injectable({
    providedIn: 'root',
})
export class RtShopFactAdapter extends TwoWayAdapter<RtShopFact> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}

@Injectable({
    providedIn: 'root',
})
export class RtShopFactMetadata implements GridColumnDescription, FormGroupDescription {
    constructor() {}
    getColumns(defaultVisibility: boolean = true): IColumnDescription[] {
        var columns = [
            {
                dataField: nameof<RtShopFact>('shopNo'),
                dataType: 'string',
                caption: 'shopNo',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtShopFact>('shopShortName'),
                dataType: 'string',
                caption: 'shopShortName',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtShopFact>('shopContact'),
                dataType: 'string',
                caption: 'shopContact',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtShopFact>('comments'),
                dataType: 'string',
                caption: 'comments',
                visible: defaultVisibility,
            } as IColumnDescription,
        ];
        return columns;
    }
    getFormGroup(obj?: any): UntypedFormGroup {
        var formGroup = new UntypedFormGroup({});
        formGroup.addControl(nameof<RtShopFact>('shopNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtShopFact>('shopShortName'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtShopFact>('shopContact'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtShopFact>('comments'), new UntypedFormControl(''));
        if (!!obj) {
            formGroup.setValue(obj);
        }
        return formGroup;
    }
}
